module.exports = __webpack_public_path__ + "static/media/mum-kids02.f5b43f0c.png";